/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    &.fill {
      fill: #ea8902;
    }
  }
`

export default class AttachedIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" css={Color}>
        <g id="그룹_5576" data-name="그룹 5576" transform="translate(-7670 -20801)">
          <rect id="사각형_5404" data-name="사각형 5404" width="20" height="20" transform="translate(7670 20801)" fill="red" opacity="0"/>
          <path id="paperclip" className="fill" d="M4.942,0A4.947,4.947,0,0,1,9.884,4.942v6.919a.659.659,0,0,1-1.318,0V4.942a3.624,3.624,0,0,0-7.248,0V12.19a2.306,2.306,0,0,0,4.613,0V5.6a.988.988,0,0,0-1.977,0v6.26a.659.659,0,0,1-1.318,0V5.6a2.306,2.306,0,0,1,4.613,0V12.19A3.624,3.624,0,0,1,0,12.19V4.942A4.947,4.947,0,0,1,4.942,0Zm0,0" transform="translate(7679.907 20802) rotate(30)" fill="#ea8902"/>
        </g>
      </svg>

    )
  }
}
